<fieldset ngModelGroup="login_type_custom_multistep">
    <div class="form-group row">
        <label for="domain_login_verify_location"
               [ngbTooltip]="'URL to redirect to if form is valid' | translate"
               [triggers]="'focus hover'"
               class="col-form-label text-bold text-right col-sm-8"
               translate>
            Verify URL*
        </label>
        <div class="col-sm-40">
            <input id="domain_login_verify_location"
                   #domainLoginVerifyLocation="ngModel"
                   name="domain_login_verify_location"
                   class="form-control"
                   [required]="true"
                   validDomain
                   [(ngModel)]="login.verify.location"/>
            <div *ngIf="domainLoginVerifyLocation?.control?.errors?.validDomain && domainLoginVerifyLocation?.control?.dirty"
                 class="invalid-feedback block" >
                <span *ngIf="domainLoginVerifyLocation?.control?.errors?.validDomain" translate>Is not a valid url</span>
            </div>
        </div>
    </div>
    <div class="form-group row">
        <label class="col-form-label text-right text-bold col-sm-8" for="login_type_custom_multistep_username" translate>
            Username
        </label>
        <div class="col-sm-40">
            <input type="text"
                   class="form-control"
                   name="login_type_custom_multistep_username"
                   [(ngModel)]="login.custom_multistep.username"
                   id="login_type_custom_multistep_username"/>
        </div>
    </div>
    <div class="form-group row">
        <label class="col-form-label text-right text-bold col-sm-8" for="login_type_custom_multistep_password" translate>
            Password
        </label>
        <div class="col-sm-40">
            <input type="password"
                   class="form-control"
                   name="login_type_custom_multistep_password"
                   [(ngModel)]="login.custom_multistep.password"
                   id="login_type_custom_multistep_password"/>
        </div>
    </div>
    <div class="form-group row" *ngFor="let step of login.custom_multistep.steps; let $index = index; trackBy: trackByFn">
        <label class="col-form-label text-right text-bold col-sm-8"
               for="login_type_custom_multistep_step_{{$index}}"
               translate>
            JS
        </label>
        <div class="col-sm-36">
            <textarea id="login_type_custom_multistep_step_{{$index}}"
                      rows="4"
                      class="form-control"
                      name="step_{{$index}}"
                      [(ngModel)]="login.custom_multistep.steps[$index]">
            </textarea>
        </div>
        <div class="col-sm-4 text-right pl-0">
            <button type="button"
                    class="btn btn-border-radius btn-secondary"
                    (click)="removeStep($index)"
                    [attr.aria-label]="'Remove Custom Multistep Javascript' | translate">
                <span class="fas fa-trash-alt" aria-hidden="true"></span>
            </button>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-40 offset-8">
            <button type="button"
                    class="btn btn-border-radius btn-secondary"
                    (click)="addStep()"
                    [attr.aria-label]="'Add Custom Multistep Javascript' | translate">
                <span class="fas fa-plus" aria-hidden="true"></span>
            </button>
        </div>
    </div>

</fieldset>
